import type { IconProps } from '@launchpad-ui/icons';
import { Icon } from '@launchpad-ui/icons';

export function RedshiftIcon(props: IconProps) {
  return (
    <Icon {...props}>
      <use href="#app-icon-redshift" />
    </Icon>
  );
}
